import { useNotification } from "@refinedev/core";
import { useEffect } from "react";


export function useProgressbar(send: boolean, timeout: number) {

    const { open, close } = useNotification();
    useEffect(() => {
        const loadingKey = 'loading-resource'
        if (send) {
            open?.({
                key: loadingKey,
                type: "progress",
                message: "Progress",
                undoableTimeout: timeout,
                // cancelMutation: () => {
                //   // when undo button is clicked, run this callback
                // },
            });
        } else {
            close?.(loadingKey)
        }
    }, [send])
}